(() => {
  'use strict';

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]'
  ].join(',');

  const disableElementFocus = (element) => {
    if (!element.hasAttribute('data-a11y-original-tabindex')) {
      element.setAttribute(
        'data-a11y-original-tabindex',
        element.getAttribute('tabindex') || ''
      );
    }
    element.setAttribute('tabindex', '-1');
  };

  const disableHiddenFocus = (container) => {
    if (container.matches(focusableSelector)) disableElementFocus(container);
    container.querySelectorAll(focusableSelector).forEach(disableElementFocus);
  };

  const restoreVisibleFocus = (container) => {
    const elements = Array.from(
      container.querySelectorAll('[data-a11y-original-tabindex]')
    );
    if (container.hasAttribute('data-a11y-original-tabindex')) {
      elements.unshift(container);
    }

    elements.forEach((element) => {
      if (element.closest('[aria-hidden="true"]')) return;
      const originalTabindex = element.getAttribute('data-a11y-original-tabindex');
      if (originalTabindex === '') {
        element.removeAttribute('tabindex');
      } else {
        element.setAttribute('tabindex', originalTabindex);
      }
      element.removeAttribute('data-a11y-original-tabindex');
    });
  };

  document.querySelectorAll('[aria-hidden="true"]').forEach(disableHiddenFocus);

  const accessibilityObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ target }) => {
      if (!(target instanceof Element)) return;
      if (target.getAttribute('aria-hidden') === 'true') {
        disableHiddenFocus(target);
      } else {
        restoreVisibleFocus(target);
      }
    });
  });

  accessibilityObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    subtree: true
  });

  let deferredAssetsLoaded = false;
  const loadDeferredAssets = () => {
    if (deferredAssetsLoaded) return;
    deferredAssetsLoaded = true;

    document.querySelectorAll('[data-deferred-src]').forEach((element) => {
      element.src = element.dataset.deferredSrc;
      element.removeAttribute('data-deferred-src');
    });

    document.querySelectorAll('[data-deferred-href]').forEach((element) => {
      element.href = element.dataset.deferredHref;
      element.removeAttribute('data-deferred-href');
    });
  };

  ['pointerdown', 'keydown', 'touchstart'].forEach((eventName) => {
    window.addEventListener(eventName, loadDeferredAssets, {
      once: true,
      passive: true
    });
  });

  let marketingPopupReady = false;
  const showMarketingPopup = () => {
    if (marketingPopupReady) return;
    marketingPopupReady = true;
    document.documentElement.classList.add('marketing-popup-ready');
  };

  ['pointerdown', 'keydown', 'touchstart'].forEach((eventName) => {
    window.addEventListener(eventName, showMarketingPopup, {
      once: true,
      passive: true
    });
  });

  window.addEventListener('load', () => {
    window.setTimeout(loadDeferredAssets, 12000);
    window.setTimeout(showMarketingPopup, 15000);
  }, { once: true });
})();
